import React, {useEffect, useState} from "react";
import {signUpApi} from "../../api/signup.js";
import {useParams} from "react-router-dom";
import {Alert, Spinner} from "react-bootstrap";
import {loadStripe} from '@stripe/stripe-js';
import {
    PaymentElement,
    Elements,
    useStripe,
    useElements,
} from '@stripe/react-stripe-js';
import {printValue} from "yup";
import PublicLayout from "../../components/publicLayout.jsx";

function ActivateUserPage() {
    const { activationKey } = useParams();
    const [pageState, setPageState] = useState({
        loading: false,
        activated: false,
        error: null
    });


    useEffect(() => {
        setPageState(prevState => {
            return {...prevState, loading: true};
        });
        const activateUser = async () => {
            await signUpApi.activateUserAccount(activationKey);
            setPageState(prevState => {
                return {...prevState, loading: false};
            });


        }

        activateUser()
            .then(() =>{
                setPageState(prevState => {
                    return {...prevState, activated: true};
                });
            })
            .catch( e => {
                setPageState( prevState => {
                    console.error(e);
                    return {...prevState, loading: false,
                        error: "An error occured while trying to activate your account. Either your account has already " +
                            "been activated or this is an invalid activation key."}
                })
            })
            .finally(() =>{
                setPageState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }, [activationKey]);

    return (
        <>
            <h1>Account activation</h1>
            {pageState.loading ? <Spinner/> : (
                <>
                    {pageState.error ? (
                        <Alert variant="danger">{pageState.error}</Alert>
                    ):(
                        <p>
                            Your account has been successfuly activated.  You may now log in and start placing orders.
                        </p>
                    )}

                </>
            )}
        </>

    )
}

export default ActivateUserPage;
